import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

const WavyLogo = ({
	height = 1024,
	width = 735,
}: { height?: string | number; width?: string | number }) => (
	<Svg
		width={width}
		height={height}
		viewBox="0 0 735 1024"
		fill="none"
		preserveAspectRatio="none"
	>
		<Path fill="#76CABB" d="M-48-17h782.526v1075.91H-48z" />
		<Path
			fill="#A2FAA8"
			d="M31.102-17h362.595s-17.804 74.065-37.162 118.17c-27.141 61.84-55.315 88.862-92.374 144.618-64.455 96.975-108.325 145.376-172.538 242.531-16.168 24.462-40.878 63.024-40.878 63.024s56.664-51.667 91.843-86.096c70.443-68.94 173.069-184.57 173.069-184.57s69.177-88.929 133.253-104.666c43.532-10.691 76.979-7.645 105.646 25.323 23.551 27.084 30.038 54.327 30.26 91.16.29 48.018-20.642 75.886-44.594 116.482-104.585 177.255-276.061 400.653-276.061 400.653s50.246-18.539 76.979-41.641c83.349-72.027 115.656-135.831 184.748-228.462 59.358-79.581 85.593-133.229 148.648-209.893 22.271-27.077 59.99-67.526 59.99-67.526V714.53s-139.604 73.388-225.095 127.737c-60.853 38.685-93.759 63.282-152.896 103.539-66.337 45.16-169.352 113.104-169.352 113.104H-48V840.016l156.081-216.083L-48 750.544v-549.21S1.974 145.781 17.83 101.17C33.288 57.68 31.102-17 31.102-17Z"
		/>
	</Svg>
)
export default WavyLogo
